// Masque le CTA sticky mobile (bas d'écran) dès que le widget billetterie
// est visible à au moins 30% — inutile d'afficher un raccourci "Book"
// par-dessus le widget qu'il est censé raccourcir.
function initBookingWidgetVisibility() {
  const widget    = document.getElementById('ndg-booking-widget');
  const ctaMobile = document.querySelector('.ndg-event-single__cta-mobile');
  if (!widget || !ctaMobile) return;

  const observer = new IntersectionObserver(
    ([entry]) => ctaMobile.classList.toggle('is-widget-visible', entry.isIntersecting),
    { threshold: 0.3 }
  );
  observer.observe(widget);
}

document.addEventListener('DOMContentLoaded', initBookingWidgetVisibility);
